import { render, staticRenderFns } from "./robotizationlabel.vue?vue&type=template&id=7def1c9f&scoped=true&"
import script from "./robotizationlabel.vue?vue&type=script&lang=js&"
export * from "./robotizationlabel.vue?vue&type=script&lang=js&"
import style0 from "./robotizationlabel.vue?vue&type=style&index=0&id=7def1c9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def1c9f",
  null
  
)

export default component.exports